/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * AssetDetailsActivity refers to current activity performed by a Machine in asset details response.
 *
 */
export var AssetDetailsActivity;
(function (AssetDetailsActivity) {
    AssetDetailsActivity["CHARGING"] = "Charging";
    AssetDetailsActivity["DISCHARGING"] = "Discharging";
    AssetDetailsActivity["IDLE"] = "Idle";
    AssetDetailsActivity["UNKNOWN"] = "Unknown";
    AssetDetailsActivity["NO_ACTIVITY_LOGGED"] = "NoActivityLogged";
    AssetDetailsActivity["TRANSPORTING"] = "Transporting";
})(AssetDetailsActivity || (AssetDetailsActivity = {}));
